import React from 'react';
import { FairnessCalculator } from '../fairness/FairnessCalculator';

export const BlackjackVerifyForm = ({ game, revealed }) => <FairnessCalculator key={game.owner} game={game} revealed={revealed} />;